import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { getCheckoutHref, handleCheckoutClick, isCheckoutConfigured } from '../utils/checkout';
import { primaryButtonClass, type ButtonSize } from '../utils/buttonStyles';
interface CheckoutButtonProps {
  label: string;
  id?: string;
  size?: ButtonSize;
  className?: string;
  tabIndex?: number;
}

/**
 * Every purchase CTA (offer, final, sticky) goes through here so they share
 * one checkout destination. Until a real checkout is configured the button
 * stays disabled instead of sending visitors somewhere wrong.
 */
export function CheckoutButton({
  label,
  id,
  size = 'md',
  className = '',
  tabIndex
}: CheckoutButtonProps) {
  const classes = `${primaryButtonClass(size)} ${className}`;
  if (!isCheckoutConfigured()) {
    return <button id={id} type="button" disabled tabIndex={tabIndex} title="Checkout is not available yet" className={`${classes} cursor-not-allowed opacity-50 hover:bg-orange active:scale-100`} data-id="element-39" data-mp="331bv0dc80zme">
        {label}
      </button>;
  }
  return <a id={id} href={getCheckoutHref()} onClick={handleCheckoutClick} tabIndex={tabIndex} className={classes} data-id="element-40" data-mp="9qglzb588pzr">
      {label}
      <ArrowRightIcon className="h-[18px] w-[18px] shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={2.5} aria-hidden data-id="element-41" data-mp="3rxegamdhzga2" />
    </a>;
}